export default __webpack_public_path__ + "img/2a91fd0cf7727a23086b53b198fe0c91.png";